import { ButtonGradientPrimary, ButtonSecondary, Colors, Icon, Spinner } from '@amelio/ui-library';

import { DraftSavedIndicator } from '@/components/DraftSavedIndicator/DraftSavedIndicator';
import { useAmelioTranslations } from '@/hooks';

interface FormNavigatorDefaultFooterProps {
    showDraftIndicator: boolean;
    lastSavedAt?: Date | null;
    onBack: () => void;
    onNext: () => void;
    isNextAvailable: boolean;
    isLoading: boolean;
    isNextDisabled?: boolean;
}

export const FormNavigatorDefaultFooter = ({
    showDraftIndicator,
    lastSavedAt,
    onBack,
    onNext,
    isNextAvailable,
    isLoading,
    isNextDisabled = false,
}: FormNavigatorDefaultFooterProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={
                'flex flex-1 flex-col items-start justify-center gap-8 p-4 sm:mt-4 sm:flex-row sm:flex-wrap sm:items-center md:gap-0 lg:p-8 xl:p-12'
            }
        >
            {showDraftIndicator && <DraftSavedIndicator lastSavedAt={lastSavedAt ?? null} />}

            <div className={'flex justify-between gap-4 sm:ml-auto'}>
                <ButtonSecondary
                    className={'text-md min-w-30 rounded-lg border border-gray-300 sm:!min-w-40'}
                    dataTestId={'back-button'}
                    onClick={onBack}
                    leftIcon={
                        <Icon
                            name={'arrow-arrow-left'}
                            className={'mr-2'}
                        />
                    }
                >
                    {t('common.back')}
                </ButtonSecondary>

                {isNextAvailable && (
                    <ButtonGradientPrimary
                        className={'text-md min-w-30 sm:min-w-40'}
                        dataTestId={'next-button'}
                        onClick={onNext}
                        disabled={isLoading || isNextDisabled}
                        rightIcon={
                            isLoading ? null : (
                                <Icon
                                    name={'arrow-arrow-right'}
                                    className={'ml-2'}
                                    color={Colors.WHITE}
                                />
                            )
                        }
                    >
                        {isLoading ? (
                            <Spinner
                                size={'sm'}
                                color={Colors.PRIMARY}
                            />
                        ) : (
                            t('common.next')
                        )}
                    </ButtonGradientPrimary>
                )}
            </div>
        </div>
    );
};
